import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./component/App";

const element = <App />;
const container = document.getElementById("root");
ReactDOM.render(element, container);